/**
 * Leaves the app for another site — Stripe's checkout or portal. One
 * function so the departure is observable in tests and never scattered.
 */
export function leaveFor(url: string): void {
  window.location.assign(url);
}
